import { ROUTES } from "../../../api/api.routes";
import useCustomQuery, { QueryOpts } from "../../../hooks/useQuery";
import { Doc } from "../../../types/db/collections";
import { GetFileResponse } from "../../../types/db/schema/files/file.schema";

export const useTools = (o?: QueryOpts) => {
  const { data, isLoading, mutate } = useCustomQuery<Doc<GetFileResponse>[]>(ROUTES.Files.Tools, o);

  console.log(data);
  return {
    tools: data,
    isLoading,
    mutate
  }
}